import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface FormEditorDrawerOptions {
  formId?: number;
  formName?: string;
}

@Injectable({ providedIn: 'root' })
export class FormEditorDrawerService {
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: FormEditorDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  readonly state = this.state$.asObservable();

  open(options: FormEditorDrawerOptions = {}): void {
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    this.state$.next({ isOpen: false, options: {} });
  }
}
